<template>
  <div class="row no-gutters body">
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../assets/pageloader.svg" class="pageloader" alt="pageloader">
    </div>
    <div class="col-12 pb-5 mb-4" v-if="!pageloader">
      <div class="row no-gutters">
        <div class="col-lg-3 middle-background"></div>
        <div class="col-md-12 col-lg-6 middle-background main-card">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters mt-5">
            <div class="col-lg-12">
              <div class="row no-gutters mt-4">
                    <br />
              </div>
                <!-- <nav class="nav card-header1 d-flex justify-content-between  ml-3 mr-3 mt-2 p-2 mb-3" id="nav">
                  <div>
                    <span>
                      <input type="radio" id="html"> <label class="fontsizemd black60 proximanova ml-2">Select All</label>
                    </span>
                  </div>
                  <span class="fontsizemd black60 proximanova mt-2">2021-Jun</span>
                </nav> -->
              <div v-if="totalPostedJobsList.length < 1">
                <no-jobs-available></no-jobs-available>
              </div>
              <div v-if="totalPostedJobsList.length > 0">
                <div v-for="(job, index) in totalPostedJobsList" :key="index">
                  <div class="shadow card mr-3 ml-3 mb-3">
                    <div class="p-2 d-flex">
                      <div class="col-2 mr-2 mr-lg-0 mr-md-0">
                        <div class="backgroundcolor1 p-lg-2 borderradius10 mr-2 mt-3 text-center">
                          <img v-if="job.companyProfileLink" :src="job.companyProfileLink" class="prof-img rounded-circle loadingBgImg" alt="companylogo">
                          <img v-else src="../assets/Profile_placehlder.svg" class="prof-img rounded-circle" alt="companylogo">
                        </div>
                      </div>
                      <div class="col-10 pl-0 pt-3 pr-3">
                        <div class="d-flex justify-content-between">
                          <div>
                            <span class="fontsize24 black proximanova-bold  mt-lg-2 pointer" @click="viewJobDetails(job)">{{job.jobTitle}}</span>
                            <select 
                              name="jobStatus"
                              :id="'jobStatus'+index" 
                              class="fontsize12 proximanova borderadius12 ml-lg-3 ml-1 mt-0 select-padding"
                              :class="{'backgroundcolor6 bordergreen stylebold green':job.jobActive==='ACTIVE', 'backgroundcolor7 red borderred stylebold':job.jobActive==='INACTIVE'}"
                              v-model="job.jobActive"
                              @change="updateJobActiveStatus(job)">
                              <option value="ACTIVE">Active</option>
                              <option value="INACTIVE">In Active</option>
                            </select>
                          </div>
                          <div class="row my-auto">
                            <span class="fontsizemd black stylebold proximanova mr-3 pointer d-none d-md-block" @click="viewJobDetails(job)">View Details</span>
                            <img src="../assets/horizontal_menu_icon.svg" width="20px" height="20px" v-popover = "{name: job.moremenu}"  class="mr-4 pointer more_optionhoriz" alt="moremenu">
                            <popover v-bind:name="job.moremenu"  class="postvideomenu" id="jobmenu">
                              <div class="p-1">                                        
                                <div class="d-flex pl-2 ml-1 action" @click="editJob(job)">
                                  <img src="../assets/Editvideo.svg" class="img-fluid" alt="edit">
                                  <span class="p-2 font14-opacity80 proximanova">Edit</span>
                                </div>
                                <div class="d-flex pl-2 ml-1 action" @click="deleteJob(job)">
                                  <img src="../assets/Deletevideo.svg" class="img-fluid" alt="delete">
                                  <span class="p-2 font14-opacity80 proximanova">Delete</span>
                                </div>
                                <div class="d-flex pl-2 ml-1 action" @click="shareJob(job)">
                                  <img src="../assets/sharejob.png" width="20" height="20" class="my-auto" alt="edit">
                                  <span class="p-2 font14-opacity80 proximanova">Share</span>
                                </div>
                                <div class="d-flex pl-2 ml-1 action" @click="copyJobLink(job)">
                                  <img src="../assets/hyperlink1.png" width="20" height="20" class="my-auto" alt="delete">
                                  <span class="p-2 font14-opacity80 proximanova">Copy link</span>
                                </div>
                              </div>
                            </popover>
                          </div>
                        </div>
                        <div class="d-flex flex-column">
                          <div class="d-flex" v-if="job.jobPostedByResponse && job.jobPostedByResponse.jobPostedByFirstName">
                            <img v-if="job.jobPostedByResponse.jobPostedprofilePicLink" :src="job.jobPostedByResponse.jobPostedprofilePicLink" width="25px" height="25px" class="rounded-circle loadingBgImg" alt="companylogo">
                            <span class="fontsizemd black proximanova mt-1 ml-1">{{job.jobPostedByResponse.jobPostedByFirstName}} {{job.jobPostedByResponse.jobPostedByLastName}}</span>
                          </div>
                          <span class="fontsize16 black proximanova mt-1">{{job.companyName}}</span>
                          <div>
                            <span class="fontsizemd black60 proximanova">{{job.industry}}</span> 
                            <span class="ml-2 mr-2 black60" v-if="job.city">|</span>
                            <span class="fontsizemd black60 proximanova" v-if="job.city">{{job.city}}</span>
                            <span class="ml-2 mr-2 black60" v-if="job.country">|</span>
                            <span class="fontsizemd black60 proximanova" v-if="job.country">{{job.country}}</span>
                          </div>
                        </div>
                        <div class="d-flex mt-2 justify-content-between">
                          <div class="mt-1">
                            <!-- <span class="fontsizemd black  proximanova-semibold">{{job.creationD | moment("from", "now", true)}} ago</span> -->
                            <span class="fontsizemd black  proximanova-semibold">{{ job.creationD | moment("MMM Do YYYY, h:mm a") }}</span>
                            <span class="ml-2 mr-2 black60"> - </span>
                            <span class="fontsizemd black60 proximanova">Hiring Within 7 days</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="borderbottom mt-2"></div>
                    <div class="backgroundcolor1  d-flex flex-wrap flex-lg-nowrap flex-md-nowrap mobileview p-1 justify-content-lg-between justify-content-sm-between ">
                      <div class="p-2 pl-lg-3 pr-lg-3 d-flex w-xs-25  flex-column  mouseoverjobsection backgroundcolor1 borderradius10 ">
                        <div class="d-flex justify-content-between">
                          <img src="../assets/JobTotalRecieved.svg" width="15px" class="img-fluid" alt="received"><span class="dot "></span>
                        </div>
                        <span class="d-flex">
                          <span class="fontsize10 black60 proximanova stylebold mt-1">Total Received</span>
                        </span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-if="job.jobStatistics" :class="{'borderbottomblue' :(job.jobStatistics.totalApplicants >= 0 && job.jobStatistics.disqualifiedCount < 1 && job.jobStatistics.reviewCount < 1 && job.jobStatistics.assessmentCount < 1 && job.jobStatistics.shortlistedCount < 1 &&  job.jobStatistics.interviewCount < 1 && job.jobStatistics.selectedCount < 1 && job.jobStatistics.hiredCount < 1)}">
                          {{job.jobStatistics.totalApplicants}}
                        </span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-else>
                          0
                        </span>
                      </div>
                      <div class="p-2 pl-lg-3 pr-lg-3 w-xs-25 d-flex flex-column mouseoverjobsection">
                        <img src="../assets/JobDisqualified.svg" width="15px" class="img-fluid" alt="disqualified">
                        <span class="fontsize10 black60 proximanova stylebold mt-1">Rejected</span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-if="job.jobStatistics" :class="{'borderbottomblue' :(job.jobStatistics.totalApplicants > 0 && job.jobStatistics.disqualifiedCount > 0 && job.jobStatistics.reviewCount < 1 && job.jobStatistics.assessmentCount < 1 && job.jobStatistics.shortlistedCount < 1 &&  job.jobStatistics.interviewCount < 1 && job.jobStatistics.selectedCount < 1 && job.jobStatistics.hiredCount < 1)}">
                          {{job.jobStatistics.disqualifiedCount}}
                        </span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-else>
                          0
                        </span>
                      </div>
                      <div class="p-2 pl-lg-3 pr-lg-3 w-xs-25 d-flex flex-column mouseoverjobsection ">
                        <img src="../assets/JobReview.svg" width="15px" class="img-fluid" alt="review">
                        <span class="fontsize10 black60 proximanova stylebold mt-1">Review</span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-if="job.jobStatistics" :class="{'borderbottomblue' :(job.jobStatistics.totalApplicants > 0 && job.jobStatistics.disqualifiedCount >= 0 && job.jobStatistics.reviewCount > 0 && job.jobStatistics.assessmentCount < 1 && job.jobStatistics.shortlistedCount < 1 &&  job.jobStatistics.interviewCount < 1 && job.jobStatistics.selectedCount < 1 && job.jobStatistics.hiredCount < 1)}">
                          {{job.jobStatistics.reviewCount}}
                        </span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-else>
                          0
                        </span>
                      </div>
                      <div class="p-2 pl-lg-3 pr-lg-3 w-xs-25 d-flex flex-column mouseoverjobsection">
                        <img src="../assets/JobAssessment.svg" width="15px" class="img-fluid" alt="assessment">
                        <span class="fontsize10 black60 proximanova stylebold mt-1">Assessment</span>
                        <span class="fontsize12 black proximanova  stylebold mt-1" v-if="job.jobStatistics" :class="{'borderbottomblue' :(job.jobStatistics.totalApplicants > 0 && job.jobStatistics.disqualifiedCount >= 0 && job.jobStatistics.reviewCount >= 0 && job.jobStatistics.assessmentCount > 0 && job.jobStatistics.shortlistedCount < 1 &&  job.jobStatistics.interviewCount < 1 && job.jobStatistics.selectedCount < 1 && job.jobStatistics.hiredCount < 1)}">
                          {{job.jobStatistics.assessmentCount}}
                        </span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-else>
                          0
                        </span>
                      </div>
                      <div class="p-2 pl-lg-3 pr-lg-3 w-xs-25 d-flex flex-column mouseoverjobsection">
                        <img src="../assets/JobShortlisted.svg" width="15px" class="img-fluid" alt="shortlisted">
                        <span class="fontsize10 black60 proximanova stylebold mt-1">Shortlisted</span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-if="job.jobStatistics" :class="{'borderbottomblue' :(job.jobStatistics.totalApplicants > 0 && job.jobStatistics.disqualifiedCount >= 0 && job.jobStatistics.reviewCount >= 0 && job.jobStatistics.assessmentCount >= 0 && job.jobStatistics.shortlistedCount > 0 &&  job.jobStatistics.interviewCount < 1 && job.jobStatistics.selectedCount < 1 && job.jobStatistics.hiredCount < 1)}">
                          {{job.jobStatistics.shortlistedCount}}
                        </span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-else>
                          0
                        </span>
                      </div>
                      <div class="p-2 pl-lg-3 pr-lg-3 w-xs-25 d-flex flex-column mouseoverjobsection">
                        <img src="../assets/JobInterview.svg" width="15px" class="img-fluid" alt="interview">
                        <span class="fontsize10 black60 proximanova stylebold mt-1">Interview</span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-if="job.jobStatistics" :class="{'borderbottomblue' :(job.jobStatistics.totalApplicants > 0 && job.jobStatistics.disqualifiedCount >= 0 && job.jobStatistics.reviewCount >= 0 && job.jobStatistics.assessmentCount >= 0 && job.jobStatistics.shortlistedCount >= 0 &&  job.jobStatistics.interviewCount > 0 && job.jobStatistics.selectedCount < 1 && job.jobStatistics.hiredCount < 1)}">
                          {{job.jobStatistics.interviewCount}}
                        </span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-else>
                          0
                        </span>
                      </div>
                      <div class="p-2 pl-lg-3 pr-lg-3 w-xs-25 d-flex flex-column mouseoverjobsection">
                        <img src="../assets/JobSelected.svg" width="15px" class="img-fluid" alt="selected">
                        <span class="fontsize10 black60 proximanova stylebold mt-1">Selected</span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-if="job.jobStatistics" :class="{'borderbottomblue' :(job.jobStatistics.totalApplicants > 0 && job.jobStatistics.disqualifiedCount >= 0 && job.jobStatistics.reviewCount >= 0 && job.jobStatistics.assessmentCount >= 0 && job.jobStatistics.shortlistedCount >= 0 &&  job.jobStatistics.interviewCount >= 0 && job.jobStatistics.selectedCount > 0 && job.jobStatistics.hiredCount < 1)}">
                          {{job.jobStatistics.selectedCount}}
                        </span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-else>
                          0
                        </span>
                      </div>
                      <div class="p-2 pl-lg-3 pr-lg-3 w-xs-25 d-flex flex-column mouseoverjobsection">
                        <img src="../assets/JobHired.svg" width="15px" class="img-fluid" alt="hired">
                        <span class="fontsize10 black60 proximanova stylebold mt-1">Hired</span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-if="job.jobStatistics" :class="{'borderbottomblue' :(job.jobStatistics.totalApplicants > 0 && job.jobStatistics.disqualifiedCount >= 0 && job.jobStatistics.reviewCount >= 0 && job.jobStatistics.assessmentCount >= 0 && job.jobStatistics.shortlistedCount >= 0 &&  job.jobStatistics.interviewCount >= 0 && job.jobStatistics.selectedCount >= 0 && job.jobStatistics.hiredCount > 0)}">
                          {{job.jobStatistics.hiredCount}}
                        </span>
                        <span class="fontsize12 black proximanova stylebold mt-1" v-else>
                          0
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 pb-5 mb-4" v-if="instancepageloader">
                  <img src="../assets/pageloader.svg" class="instancepageloader" alt="pageloader">
                </div>
              </div>
            </div>
          </div>
          <activeinactive-job-modal v-if="activeinactivemodal" @closeActiveInactiveJobModal="closeActiveInactiveJobModal"></activeinactive-job-modal>
          <delete-job-modal v-if="deleteJobModal" :deleteJobObject="deleteJobObject" @closeDeleteJobModal="closeDeleteJobModal"></delete-job-modal>
          <APIErrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIErrorModal>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Popover from "vue-js-popover";
import httpbusiness from "@/js/http-business.js"
import httpjob from "@/js/http-postjob.js"
import router from '../router.js'
import moment from 'vue-moment'
import { bus } from "@/main.js";
import deleteJobModal from '../components/DeleteJobComponent.vue'
import activeinactiveJobModal from '../components/ActiveInactiveJodModal.vue'
import noJobsAvailable from '../components/NoJobsAvailable.vue'
import APIErrorModal from '../components/APIerrorpopup.vue'
import commonUtils from '@/js/common-utils.js'
import sessionUtils from "@/js/session-util.js";
Vue.use(Popover);
export default{
    components:{
      deleteJobModal,
      noJobsAvailable,
      activeinactiveJobModal,
      APIErrorModal
    },
    data(){
      return{
        displayAPIerrorModal : false,
        pageloader: true,
        instancepageloader : false,
        jobStatus : 'ACTIVE',
        totalPostedJobsList : [],
        instanceJobsList : [],
        companyProfileId : null,
        employeeId : null,
        isScrolled : false,
        limit : 10,
        offset : 0,
        deleteJobModal : false,
        deleteJobObject : {
          jobId : ''
        },
        //if recruiter login
        recruiterAccountStatus : 'ACCEPT',
        //job active-inactive
        activeinactivemodal : false,
        activatedJob : null,
        prevjobActiveStatus : null,
      }
    },
    methods:{
      //copy & share job link
      copyJobLink(jobObj) {
        commonUtils.copyJobLink(jobObj)
      },
      shareJob : function(jobObj){
        commonUtils.shareJob(jobObj)
      },
      closeAPIerrorModal(){
        this.displayAPIerrorModal = false;
      },
      // this will invoke after changing job status from dropdown
      changeJobActiveStatus(job){
        var vm = this;
        console.log(job.jobActive)
        httpjob.put('/postjob/updateJobActiveStatusById?jobId='+job.jobId+'&jobActive='+job.jobActive)
        .then((response) => {
          console.log(response)
          vm.$toast.success(response.data.errorMessage)
        }).catch((e) => {
          console.log(e)
          // vm.$toast.error(e.data.errorMessage)
          this.displayAPIerrorModal = true;
        })
      },
      // this will invoke after click on job title/ view details 
      // navigate user to selected job page
      viewJobDetails(job) {
        console.log(job)
        sessionUtils.setSelectedJobId(job.jobId)
        router.push({
          name : 'viewjob', params: { id: job.jobId}
        })
      },
      // this will invoke after click on edit button on moremenu of a job
      // navigate to edit page
      editJob(job){
        console.log(job)
        sessionUtils.setSelectedJobId(job.jobId)
        router.push({
          name : 'editjob'
        })
      },
      // open delete confirmation modal after click on delete button
      deleteJob(job){
        console.log(job)
        this.deleteJobObject.jobId = job.jobId;
        this.deleteJobModal = true;
        // var vm = this;
        // httpjob.put('/postjob/updateJobStatusById?jobId='+job.jobId+'&jobStatus=DELETE')
        // .then((response) => {
        //   console.log(response)
        //   vm.$toast.success(response.data.errorMessage)
        //   this.resetData()
        // }).catch((e) => {
        //   console.log(e)
        //   vm.$toast.error(e.data.errorMessage)
        // })
      },
      //this will invoke after click on close btn in delete job modal component
      closeDeleteJobModal(statusObj) {
        this.deleteJobModal = false;
        if(statusObj === 'SUCCESS') {
          this.resetData()
        }
        console.log("delete job : ", statusObj)
      },
      // this will invoke after change
      updateJobActiveStatus(job){
        this.activatedJob = job;
        if(job.jobActive == 'INACTIVE'){
          this.activeinactivemodal = true;
          this.prevjobActiveStatus = 'ACTIVE'
        }else{
          this.changeJobActiveStatus(this.activatedJob)
          this.activatedJob = null;
          this.prevjobActiveStatus = null
        }
      },
      // this will invoke after closing the activeincative popup
      closeActiveInactiveJobModal(statusObj) {
        this.activeinactivemodal = false;
        if(statusObj === 'SUCCESS') {
          this.changeJobActiveStatus(this.activatedJob)
        }else{
          this.activatedJob.jobActive = this.prevjobActiveStatus;
        }
        this.activatedJob = null;
        this.prevjobActiveStatus = null
      },
      resetData(){
        this.offset = 0;
        this.pageloader = true;
        this.totalPostedJobsList = []
        this.instanceJobsList = []
        this.isScrolled = true;
        this.getPostedJobsList()
      },
      //this will invoke after component mounted to get posted jobs list
      getPostedJobsList(){
        var vm = this;
        httpjob.get('/postjob/getListByJobStatus?companyProfileId='+this.companyProfileId+'&employeeId='+this.employeeId+'&jobStatus=POST&limit='+this.limit+'&offset='+this.offset)
        .then((response) => {
          this.pageloader = false;
          this.instancepageloader = false;
          this.isScrolled = false;
          console.log(response)
          this.instanceJobsList = response.data;
          if(this.instanceJobsList.length > 0){
            for(var i =0; i < this.instanceJobsList.length; i++){
              this.instanceJobsList[i].moremenu = "closemore"+this.instanceJobsList[i].jobId
              this.instanceJobsList[i].jobStatistics = this.instanceJobsList[i].jobStatistics[0]
              this.totalPostedJobsList.push(this.instanceJobsList[i])
            }
          }
          if(this.instanceJobsList.length < 1) {
            vm.$toast.success("No More Jobs available")
          }
          // this.jobsList = response.data;
        }).catch((e) => {
          console.log(e.response)
          this.instancepageloader = false;
          this.pageloader = false;
          this.displayAPIerrorModal = true;
        })
      },
      //this will invoke after scrolling down to get more records
      postedJobsPageScroll () {
        if(!this.isScrolled && this.instanceJobsList.length > 0){               
          if (((window.innerHeight + window.scrollY +1) >= document.body.offsetHeight) && !this.showdropdown && !this.noResults) {            
            this.isScrolled = true;    
            this.offset = this.offset+10;
            this.instancepageloader = true
            this.getPostedJobsList()        
          }        
        }
      },
    },
    mounted() {
      window.scrollTo(0, 0);
      this.companyProfileId = sessionUtils.getCompanyProfileId();
      this.employeeId = sessionUtils.getBusinessAccountId();
      if(sessionUtils.getmodule() == 'Recruiter'){
        this.recruiterAccountStatus = sessionUtils.getRecruiterAccountStatus()
      }
      if(this.companyProfileId && this.companyProfileId!='undefined' && this.companyProfileId != 'null' && this.recruiterAccountStatus=='ACCEPT'){
      this.getPostedJobsList()
      }else{
        this.pageloader = false;
      }
      bus.$on("refreshPostedJobsList", data => {
        if(data){
          this.resetData()
        }
      })
    },
    created(){
      window.addEventListener('scroll', this.postedJobsPageScroll);
    },
    beforeDestroy(){
      window.removeEventListener('scroll', this.postedJobsPageScroll);
      bus.$off('refreshPostedJobsList')
    }
}
</script>
<style scoped>
.card-header1 {
  border: 1px solid #d9dce1;
  opacity: 1;
  border-radius: 8px;
}  
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
  
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.action:hover{
  background: #dddfe5;
  border-radius: 10px;
  cursor: pointer;
}
.jobsection{
  overflow-x: auto;
}
.instancepageloader{
  width: 7%;
  margin-left: 48%;
  margin-top: 2%;
  margin-bottom: 2%;
}
.dot{
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background-color: tomato;
}
select > option{
  background-color: white;
  color: black;
}
.prof-img{
  width: 50px;
  height: 50px
}
.dropdown-position-bottom.postvideomenu {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width: 140px !important;
    left: unset !important;
  }
  .vue-popover.dropdown-position-bottom.postvideomenu:before {
    display: none !important;
  }
@media screen and (min-width: 550px) and (max-width: 768px) {
   .dropdown-position-bottom.postvideomenu {
    transform: translate3d(-10%,0,0);
  }  
}
@media screen and  (max-width: 550px) {
   .dropdown-position-bottom.postvideomenu {
    transform: translate3d(-75%,0,0);
  }  
}
@media (max-width: 575.98px) {
  .w-xs-100 {
    width: 100% !important;
  }

  .w-xs-75 {
    width: 75% !important;
  }

  .w-xs-50 {
    width: 50% !important;
  }

  .w-xs-25 {
    width: 25% !important;
  }
}
@media only screen and (min-width: 992px) {
  .mobileview{
  overflow: auto;
} 
}
@media only screen and (max-width: 600px) {
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
  .fontsize24{
    font-size: 14px
  }
  .fontsize16 {
    font-size: 12px;
}
.fontsizemd {
    font-size: 12px !important;
}
   .prof-img {
    width: 36px;
    height: 36px;
}
.fontsize12 {
    font-size: 8px;
}
  
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
</style>
